import { render } from "./CreateProjectMenu.vue?vue&type=template&id=ec0870a6&scoped=true&lang=html"
import script from "./CreateProjectMenu.vue?vue&type=script&lang=js"
export * from "./CreateProjectMenu.vue?vue&type=script&lang=js"

import "./CreateProjectMenu.vue?vue&type=style&index=0&id=ec0870a6&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0870a6"]])

export default __exports__